import { fetchUserAttributes } from "aws-amplify/auth"

export const getShopId = async () => {
  const userAttributes = await fetchUserAttributes()
  return userAttributes["custom:shopId"]
}
